import { createLogger } from '@fe-toolkit/observability/client'

const logger = createLogger({ name: 'broadband-profile-fe' })

export default logger
